var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgI1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1762",
    "data-name": "Group 1762",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.331,
    height: 21.339,
    viewBox: "0 0 21.331 21.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 21.331,
    height: 21.339,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M9.691,4.894c0,1.227,0,2.454,0,3.681,0,.766-.348,1.117-1.108,1.118q-3.748.007-7.5,0A.959.959,0,0,1,0,8.6Q0,4.848,0,1.1A.957.957,0,0,1,1.088,0Q4.858,0,8.629,0a.948.948,0,0,1,1.06,1.072c.008,1.272,0,2.545,0,3.817M1.973,7.731H7.719V1.95H1.973Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M137.729,4.846c0,1.242,0,2.484,0,3.726,0,.768-.347,1.119-1.105,1.121q-3.748.007-7.5,0A.958.958,0,0,1,128.042,8.6q-.007-3.749,0-7.5A.958.958,0,0,1,129.124,0q3.77-.008,7.54,0a.948.948,0,0,1,1.062,1.07c.008,1.257,0,2.514,0,3.772m-1.971-2.88h-5.746v5.78h5.746Z",
    transform: "translate(-116.399 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M4.8,137.781c-1.226,0-2.453,0-3.679,0-.764,0-1.115-.35-1.116-1.109Q0,132.944,0,129.218c0-.789.345-1.127,1.143-1.129q3.7-.005,7.4,0c.8,0,1.138.339,1.139,1.132q.006,3.726,0,7.452c0,.76-.352,1.1-1.12,1.106-1.257.005-2.514,0-3.77,0m2.944-7.72H1.967v5.747H7.744Z",
    transform: "translate(-0.002 -116.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M128.088,133a4.842,4.842,0,1,1,4.827,4.826A4.824,4.824,0,0,1,128.088,133m4.8,2.888a2.908,2.908,0,1,0-2.87-2.923,2.911,2.911,0,0,0,2.87,2.923",
    transform: "translate(-116.444 -116.487)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.bbf3bcc94ad31dfc215e1701d8804828.svg";
export { ForwardRef as ReactComponent };